/**
 * Sealed
 * @author LL
 * @date 2022-01-20 下午 12:23
 **/
export function Sealed(constructor: Function) {
    Object.seal(constructor)
    Object.seal(constructor.prototype)
}
